import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import CanceledIcon from '@mui/icons-material/Cancel';
import { FormattedMessage } from 'react-intl';

import Spacings from '~/modules/ui-kit/spacings';
import messages from './messages';
import styles from './styles.module.css';

type TurnCanceledViewProps = {
  reason?: string;
};

const TurnCanceledView = (props: TurnCanceledViewProps) => {
  const theme = useTheme();
  return (
    <Spacings.Stack alignItems="center" className={styles.stack}>
      <div className={styles.icon}>
        <CanceledIcon
          style={{
            width: '30vh',
            height: '30vh',
            color: theme.palette.grey[200],
          }}
        />
      </div>
      <Typography variant="h5" color="textSecondary" align="center">
        <FormattedMessage {...messages.turnCanceled} />
      </Typography>
      <Typography color="textSecondary" align="center">
        {props.reason}
      </Typography>
    </Spacings.Stack>
  );
};

export default TurnCanceledView;
